import 'semantic-ui-less/definitions/elements/icon.less';import _default from './Icon';
export { _default as default };